// extracted by mini-css-extract-plugin
module.exports = {"chart_card":"ChartCard_chart_card__3Xbqr","chart_card_title":"ChartCard_chart_card_title__C17KD","chart_card_content":"ChartCard_chart_card_content__1gv5a"};